import React, { useState } from "react";
import PageHeader from "../../components/common/PageHeader/PageHeader";
import SimpleSearchBox from "../../components/common/Search/SimpleSearch";
import Filter from "../../components/common/Filter/Filter";
import Sort from "../../components/common/Sort/Sort";


const AccessLogs = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filterOption, setFilterOption] = useState("Default");
  const [sortOption, setSortOption] = useState("Default");

  const accessLogsData = [
    {
      id: 1,
      company: "MetroMart",
      user: "Johndoe_92",
      ip: "192.168.45.78",
      device: "Desktop",
      os: "MacOS",
      browser: "Safari",
      time: "March 28, 2025, 14:37 UTC",
      location: "New York, USA",
    },
    {
      id: 2,
      company: "GlobalGrocers",
      user: "Emily_walker21",
      ip: "203.112.56.149",
      device: "Desktop",
      os: "Win10",
      browser: "Google Chrome",
      time: "March 28, 2025, 19:22 UTC",
      location: "London, UK",
    },
  ];

  return (
    <div className='whole-container'>
      <div className='top-heading'>
        <PageHeader pageName="Subscription /" nestedpageName="Access Logs" linkTo="" />
      </div>

      <div className='pagename-container'>
        <div className='page-name'>
          <h1 className='common-text fts-22 ftw-6 blue'>Access Logs</h1>
        </div>
        <div className='pagename-right-container'>
          <SimpleSearchBox placeholder="Search" onSearchSelect={setSearchTerm} defaultValue={searchTerm} />
          <Filter options={["Default"]} onFilterSelect={setFilterOption} defaultValue={filterOption} />
          <Sort options={["Default"]} onOptionSelect={setSortOption} defaultValue={sortOption} />
        </div>
      </div>

      <div className='table-container'>
        <table className='common-table'>
          <thead className='common-table-head'>
            <tr className='common-table-thead-tr'>
              <th>
                <input
                  className="table-selectbox table-parent-selectbox"
                  type="checkbox"
                //   checked={isParentSelected}
                //   onChange={handleParentCheckboxChange}
                />
               Company</th>
              <th>User</th>
              <th>IP Address</th>
              <th>Device</th>
              <th>OS</th>
              <th>Browser</th>
              <th>Time</th>
              <th>Location</th>
            </tr>
          </thead>
          <tbody className='common-table-tbody'>
            {accessLogsData.map((log) => (
              <tr key={log.id}>
                <td>
                     <input
                      className="table-selectbox table-child-selectbox"
                      type="checkbox"
                      />
                    {log.company}
                </td>
                <td>{log.user}</td>
                <td>{log.ip}</td>
                <td>{log.device}</td>
                <td>{log.os}</td>
                <td>{log.browser}</td>
                <td>{log.time}</td>
                <td>{log.location}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AccessLogs;